import { Observable } from 'rxjs';
import { APIResponseWrapper } from '../../models/common/api-response-wrapper';
import * as HrModels from '../hr.models';
import { Constructor, HrApiClient } from '../shared/hr-api-client';

export function withHrLeaveApi<TBase extends Constructor<HrApiClient>>(Base: TBase) {
  return class extends Base {
    leaveDashboard(owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrLeaveDashboard>> {
        return this.http.get<APIResponseWrapper<HrModels.HrLeaveDashboard>>(`${this.baseUrl}/leave/dashboard`, {
          params: this.params({ owningCompanyId })
        });
      }
    
    leaveCalendars(owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrCalendar[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrCalendar[]>>(`${this.baseUrl}/leave/calendars`, {
          params: this.params({ owningCompanyId })
        });
      }
    
    saveLeaveCalendar(request: HrModels.HrCalendar): Observable<APIResponseWrapper<HrModels.HrCalendar>> {
        return request.calendarId
          ? this.http.put<APIResponseWrapper<HrModels.HrCalendar>>(`${this.baseUrl}/leave/calendars/${request.calendarId}`, request)
          : this.http.post<APIResponseWrapper<HrModels.HrCalendar>>(`${this.baseUrl}/leave/calendars`, request);
      }
    
    leaveHolidays(owningCompanyId?: number, from?: string, to?: string): Observable<APIResponseWrapper<HrModels.HrHoliday[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrHoliday[]>>(`${this.baseUrl}/leave/holidays`, {
          params: this.params({ owningCompanyId, from, to })
        });
      }
    
    saveLeaveHoliday(request: HrModels.HrHoliday): Observable<APIResponseWrapper<HrModels.HrHoliday>> {
        return request.holidayId
          ? this.http.put<APIResponseWrapper<HrModels.HrHoliday>>(`${this.baseUrl}/leave/holidays/${request.holidayId}`, request)
          : this.http.post<APIResponseWrapper<HrModels.HrHoliday>>(`${this.baseUrl}/leave/holidays`, request);
      }
    
    leaveTypes(owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrLeaveType[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrLeaveType[]>>(`${this.baseUrl}/leave/types`, {
          params: this.params({ owningCompanyId })
        });
      }
    
    saveLeaveType(request: HrModels.HrLeaveType): Observable<APIResponseWrapper<HrModels.HrLeaveType>> {
        return request.leaveTypeId
          ? this.http.put<APIResponseWrapper<HrModels.HrLeaveType>>(`${this.baseUrl}/leave/types/${request.leaveTypeId}`, request)
          : this.http.post<APIResponseWrapper<HrModels.HrLeaveType>>(`${this.baseUrl}/leave/types`, request);
      }
    
    leaveRequests(owningCompanyId?: number, status?: string, from?: string, to?: string, employeeId?: number, limit?: number): Observable<APIResponseWrapper<HrModels.HrLeaveRequest[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrLeaveRequest[]>>(`${this.baseUrl}/leave/requests`, {
          params: this.params({ owningCompanyId, status, from, to, employeeId, limit })
        });
      }
    
    submitLeaveRequest(employeeId: number, request: HrModels.HrLeaveRequest): Observable<APIResponseWrapper<HrModels.HrLeaveRequest>> {
        return this.http.post<APIResponseWrapper<HrModels.HrLeaveRequest>>(`${this.baseUrl}/employees/${employeeId}/leave/request`, request);
      }
    
    approveLeaveRequest(leaveRequestId: number, request: HrModels.HrLeaveDecisionRequest = {}): Observable<APIResponseWrapper<HrModels.HrLeaveRequest>> {
        return this.http.post<APIResponseWrapper<HrModels.HrLeaveRequest>>(`${this.baseUrl}/leave/requests/${leaveRequestId}/approve`, request);
      }
    
    rejectLeaveRequest(leaveRequestId: number, request: HrModels.HrLeaveDecisionRequest = {}): Observable<APIResponseWrapper<HrModels.HrLeaveRequest>> {
        return this.http.post<APIResponseWrapper<HrModels.HrLeaveRequest>>(`${this.baseUrl}/leave/requests/${leaveRequestId}/reject`, request);
      }
    
    leaveBalances(owningCompanyId?: number, employeeId?: number, periodStart?: string, periodEnd?: string): Observable<APIResponseWrapper<HrModels.HrLeaveBalance[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrLeaveBalance[]>>(`${this.baseUrl}/leave/balances`, {
          params: this.params({ owningCompanyId, employeeId, periodStart, periodEnd })
        });
      }
    
    recalculateLeaveBalances(request: HrModels.HrLeaveBalanceRecalculateRequest): Observable<APIResponseWrapper<HrModels.HrLeaveBalance[]>> {
        return this.http.post<APIResponseWrapper<HrModels.HrLeaveBalance[]>>(`${this.baseUrl}/leave/balances/recalculate`, request);
      }
    
    leaveCalendar(owningCompanyId?: number, from?: string, to?: string, employeeId?: number): Observable<APIResponseWrapper<HrModels.HrLeaveCalendarEntry[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrLeaveCalendarEntry[]>>(`${this.baseUrl}/leave/calendar`, {
          params: this.params({ owningCompanyId, from, to, employeeId })
        });
      }
  };
}

